import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import useCountUp from '../hooks/useCountUp';

export default function CountUpStat({ end, prefix = '', suffix = '', decimals = 0, duration = 1500, className = '' }) {
  const [ref, visible] = useScrollReveal({ threshold: 0.4 });
  const value = useCountUp({ end, duration, start: visible, decimals });
  return (
    <span ref={ref} className={className}>
      {prefix}{value}{suffix}
    </span>
  );
}
